import React from "react";
import PropTypes from "prop-types";
import "./CustomLoading.css";
import loaderImage from "../../assets/icons/part-logo.png";


const CustomLoading = ({ imageSrc, size = 50 }) => {
    return (
        <div
            className="custom-loading"
            style={{
                width: size,
                height: size,
                backgroundImage: `url(${imageSrc || loaderImage})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
            }}
        />
    );
};

CustomLoading.propTypes = {
    imageSrc: PropTypes.string.isRequired, // The path to the PNG image
    size: PropTypes.number, // The size of the loader
};

export default CustomLoading;
